import { Link } from "react-router-dom";
import { Eye } from "lucide-react";
import type { ColumnDef } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import type { Invoice } from "@/lib/invoice.api";
import { fmtDate, lineSummary, money } from "@/pages/documents/components/DocumentWorkspace";
import { getInvoiceLabel } from "./invoice-formatters";
import { InvoiceStatusBadges } from "./components/InvoiceStatusBadges";

export function createInvoiceColumns(
  onQuickView: (invoice: Invoice) => void,
): ColumnDef<Invoice, any>[] {
  return [
    {
      id: "number",
      header: "Facture",
      cell: ({ row }) => (
        <div>
          <Link
            to={`/invoices/${row.original.id}`}
            className="text-[12px] font-medium text-brand-gold-dark hover:underline"
            onClick={(event) => event.stopPropagation()}
          >
            {getInvoiceLabel(row.original)}
          </Link>
          <p className="mt-0.5 text-[10.5px] text-muted-foreground">
            {lineSummary(row.original.lines)}
          </p>
        </div>
      ),
    },
    {
      id: "party",
      header: "Client",
      cell: ({ row }) => (
        <div>
          <p className="text-[12px] font-medium text-body">
            {row.original.partySnapshot?.fullName ?? "-"}
          </p>
          <p className="mt-0.5 text-[10.5px] text-muted-foreground">
            {row.original.partySnapshot?.phone ??
              row.original.partySnapshot?.email ??
              "Contact non renseigné"}
          </p>
        </div>
      ),
    },
    {
      id: "total",
      header: "Total",
      meta: { align: "right" },
      cell: ({ row }) => (
        <span className="text-[12px] font-semibold tabular-nums text-foreground">
          {money(row.original.totalAmount)}
        </span>
      ),
    },
    {
      id: "dates",
      header: "Dates",
      cell: ({ row }) => (
        <div className="text-[12px] text-muted-foreground">
          <p>Créée: {fmtDate(row.original.createdAt)}</p>
          <p>Échéance: {fmtDate(row.original.dueDate)}</p>
        </div>
      ),
    },
    {
      id: "status",
      header: "Statuts",
      cell: ({ row }) => <InvoiceStatusBadges invoice={row.original} />,
    },
    {
      id: "actions",
      header: "",
      meta: { align: "right" },
      cell: ({ row }) => (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          title="Aperçu rapide"
          onClick={(event) => {
            event.stopPropagation();
            onQuickView(row.original);
          }}
        >
          <Eye size={13} />
        </Button>
      ),
    },
  ];
}
